export default "__VITE_ASSET__DOpvgPuU__"